import { resolveMediaUrl } from '@/utils/mediaUrl'

const TYPE_ICON_MAP = {
  achievement: 'AwardIcon',
  ad_notification: 'BellIcon',
  system: 'InfoIcon',
  message: 'MailIcon',
  alert: 'AlertCircleIcon',
}

export const VENDOR_NOTIFICATIONS_UPDATED_EVENT = 'vendor-notifications-updated'

export const getInitials = value => {
  const source = String(value || '').trim()
  if (!source) return 'NA'

  const parts = source.split(/\s+/).filter(Boolean)
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase()
  }

  return parts.slice(0, 2).map(part => part.charAt(0).toUpperCase()).join('')
}

export const normalizeVendorNotification = item => {
  const sourceName = item?.user?.name || 'System'
  const data = item?.data && typeof item.data === 'object' ? item.data : {}

  return {
    id: String(item?.id || ''),
    title: item?.title || sourceName || 'Notification',
    message: item?.message || '',
    timestamp: item?.time_ago || '',
    createdAt: item?.created_at || '',
    isRead: Boolean(item?.is_read),
    avatar: resolveMediaUrl(item?.user?.avatar || ''),
    initials: getInitials(sourceName),
    icon: TYPE_ICON_MAP[item?.type] || 'BellIcon',
    sourceName,
    type: item?.type || 'ad_notification',
    data,
    redirectType: String(item?.redirect_type || data.redirect_type || ''),
    adId: Number(item?.ad_id || data.ad_id || 0) || null,
    companyId: Number(item?.company_id || data.company_id || 0) || null,
  }
}

export const resolveVendorNotificationRoute = item => {
  if (!item) return null

  const redirect = item.redirectType || item.data?.redirect_type || ''
  const adId = item.adId || item.data?.ad_id

  if (redirect === 'ad' && adId) {
    return { name: 'my-ads-detail', params: { id: String(adId) } }
  }

  if (redirect === 'company') {
    return { name: 'admin' }
  }

  if (redirect === 'plan' || redirect === 'payment') {
    return { name: 'Plan Renewal' }
  }

  return null
}

export const parseVendorNotificationsResponse = response => {
  const payload = response?.data?.data || {}
  const pagination = response?.data?.pagination || payload?.pagination || {}

  return {
    notifications: Array.isArray(payload.notifications)
      ? payload.notifications.map(normalizeVendorNotification)
      : [],
    unreadCount: Number(payload.unread_count ?? response?.data?.meta?.unread_count ?? 0),
    pagination: {
      total: Number(payload.total ?? pagination.total ?? 0),
      currentPage: Number(payload.current_page ?? pagination.current_page ?? pagination.page ?? 1),
      perPage: Number(payload.per_page ?? pagination.per_page ?? pagination.limit ?? 10),
      totalPages: Number(pagination.total_pages ?? pagination.last_page ?? 1),
    },
  }
}

export const emitVendorNotificationsUpdated = detail => {
  if (typeof window === 'undefined') return

  window.dispatchEvent(new CustomEvent(VENDOR_NOTIFICATIONS_UPDATED_EVENT, { detail }))
}
